"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var feedback_context_1 = require("./feedback-context");
var dialog_1 = __importDefault(require("./dialog"));
var form_1 = __importDefault(require("./form"));
var Feedback = function () {
    var _a = (0, feedback_context_1.useFeedback)(), isFeedbackDialogOpen = _a.isFeedbackDialogOpen, setIsFeedbackDialogOpen = _a.setIsFeedbackDialogOpen, location = _a.location;
    var handleCloseDialog = function () {
        setIsFeedbackDialogOpen(false, 'navigation');
    };
    return ((0, jsx_runtime_1.jsx)(dialog_1.default, { title: "Tell us what you think!", isOpen: isFeedbackDialogOpen, handleCloseDialog: handleCloseDialog, children: (0, jsx_runtime_1.jsx)(form_1.default, { location: location }) }));
};
exports.default = Feedback;
